import React from 'react';
import { connect } from 'react-redux';
import { ConfirmationDialog } from '../Ui';
import { getDialog, doHideDialog } from '../reducers/app/dialog';

const DIALOG_COMPONENTS = {
	CONFIRMATION_DIALOG: ConfirmationDialog
};

const DialogRoot = ({ dialogType, dialogProps, dispatch }) => {
	if (!dialogType) {
		return null;
	}

	const SpecificDialog = DIALOG_COMPONENTS[dialogType];
	// onCancel is general to all dialog components
	return (
		<SpecificDialog
			onCancel={() => dispatch(doHideDialog())}
			{...dialogProps}
		/>
	);
};

export default connect(state => getDialog(state))(DialogRoot);



// WEBPACK FOOTER //
// ./src/js/app/DialogRoot.js